export const localDateToISODate = (text: string): string => {
  const digits = text.replace(/[^0-9]/g, "")
  const day = digits.slice(0, 2)
  const month = digits.slice(2, 4)
  const year = digits.slice(4, 8)

  return `${year}-${month}-${day}`
}